import React, { useState, useCallback } from 'react'
interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
}
export function useErrorBoundary(): [
  ErrorBoundaryState,
  (error: Error) => void,
  () => void,
] {
  const [errorState, setErrorState] = useState<ErrorBoundaryState>({
    hasError: false,
    error: null,
  })
  const handleError = useCallback((error: Error) => {
    setErrorState({ hasError: true, error })
    // Log error to your error reporting service
    console.error('Error caught by boundary:', error)
  }, [])
  const resetError = useCallback(() => {
    setErrorState({ hasError: false, error: null })
  }, [])
  return [errorState, handleError, resetError]
}